import { createContext, RefObject, useRef, useState } from 'react';

type ScrollContextType = {
  tutorialSectionRef: RefObject<HTMLDivElement>;
  scrollToTutorialSection: () => void;
  highlightTutorialSection: boolean;
};

export const ScrollContext = createContext<ScrollContextType | undefined>(
  undefined,
);

export const ScrollProvider = ({ children }: { children: React.ReactNode }) => {
  const tutorialSectionRef = useRef<HTMLDivElement>(null);
  const [highlightTutorialSection, setHighlightTuhighlightTutorialSection] =
    useState(false);

  const scrollToTutorialSection = () => {
    if (tutorialSectionRef.current) {
      tutorialSectionRef.current.scrollIntoView({ behavior: 'smooth' });
      setHighlightTuhighlightTutorialSection(true);
      setTimeout(() => setHighlightTuhighlightTutorialSection(false), 3000);
    }
  };

  return (
    <ScrollContext.Provider
      value={{
        tutorialSectionRef,
        scrollToTutorialSection,
        highlightTutorialSection,
      }}
    >
      {children}
    </ScrollContext.Provider>
  );
};
